export default "32b22a79562e34b7fa800fd40308fe24.png";